export default __webpack_public_path__ + "static/media/nhl-gear.c9a6219b.png";